import React from 'react';
import { Row, Col } from 'antd';
import styled from 'styled-components';
import StyledFooter from './style';
import SOCIAL_DATA from './SocialData';
import { constants } from '../../devUtils';
import endPoints from '../../config/endPoints';

const CustomContainer = styled.div`
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  box-sizing: border-box;
  padding: 0px 10px;
  @media (min-width: 576px) {
    max-width: 540px;
    box-sizing: border-box;
  };
  @media (min-width: 768px) {
    max-width: 720px;
    padding: 0px;
  };
  @media (min-width: 992px) {
    max-width: 960px;
    padding: 0px;
  };
  @media (min-width: 1200px) {
    max-width: 1140px;
    padding: 0px;
  };
  @media (min-width: 1530px) {
    max-width: 1420px;
    padding: 0px;
  };
`;

const FooterSegment = styled.section`
  @media screen and (max-width: ${({ theme }) => theme.breakpoints[2]}) {
    position: relative;
  };
  .copyrights{
    font-size: 12px;
    margin: 0px;
    font-weight: normal;
    text-align: center;
    ul{
    margin:0px;
    padding:0px;
    list-style:none;
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    li{
      margin:0px;
      a{
        &:hover{
          color: ${({ theme }) => theme.primaryLight};
        }
      }
    }
  }
  }
`;

function FooterNew() {
  const currentYear = new Date().getFullYear();
  const {
    LINK_SAVE,
    LINK_EMS,
    ZAGGLE_EMPLOYEE_PURCHASE_PROGRAM,
    LINK_PROPEL,
    LINK_TAXSPANNER,
    ZAGGLE_CLOSED_LOOP_CARDS,
    ZAGGLE_INTERNATIONAL_PAYMENTS,
    LINK_MANAGE_ZAGGLE_CARD,
    LINK_GIFTCARD_LANDING,
    LINK_ZAGGLE_CREDIT_CARDS,
    ABOUT_US,
    CAREERS,
    PRESS,
    CONTACT_US,
    TRUST_CENTER,
    FAQS,
    INVESTOR_RELATIONS,
    SOLUTIONS_MID_RANGE_COMPANIES,
    SOLUTIONS_CORPORATE,
    ANDROID_APP,
    IOS_APP,
    GRIVANCE_POLICY,
    REFUND_POLICY,
    PRIVACY_POLICY,
    TERMS_AND_CONDITIONS,
    LINK_ZAGGLEZOYER,
    LINK_BROME,
    LINK_FOREX_SERVICES,
  } = constants;
  return (
    <FooterSegment>
      <StyledFooter>
        <CustomContainer>
          <Row type="flex" justify="space-start" align="top" className="padding-t-3">

            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
              <ul>
                <h4 className="border-left-primary">PRODUCTS</h4>
                <div className="margin-l-1">
                  <li><strong>Save</strong></li>
                  <li><a href={LINK_SAVE} target="_blank" rel="noreferrer">Employee Flexi Benefits</a></li>
                  <li><a href={LINK_EMS} target="_blank" rel="noreferrer">Employee Expenses</a></li>
                  <li><a href={ZAGGLE_EMPLOYEE_PURCHASE_PROGRAM} target="_blank" rel="noreferrer">Employee Purchase Program</a></li>
                  <li><a href={LINK_PROPEL} target="_blank" rel="noreferrer"><strong>Propel</strong></a></li>
                  <li><strong>Zoyer</strong></li>
                  <li><a href={LINK_ZAGGLEZOYER} rel="noreferrer">Procure-to-Pay</a></li>
                  <li><a href={LINK_BROME} target="_blank" rel="noreferrer">BROME</a></li>
                  <li><a href={LINK_TAXSPANNER} target="_blank" rel="noreferrer"><strong>Tax Solutions</strong></a></li>
                  <li><a href={ZAGGLE_CLOSED_LOOP_CARDS} target="_blank" rel="noreferrer"><strong>Fleet Management</strong></a></li>
                  <li><a href={ZAGGLE_INTERNATIONAL_PAYMENTS} target="_blank" rel="noreferrer"><strong>Zaggle International Payments</strong></a></li>
                </div>
              </ul>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4}>
              <ul>
                <h4 className="border-left-primary">CARDS &amp; PAYMENTS</h4>
                <div className="margin-l-1">
                  <li><a href={LINK_MANAGE_ZAGGLE_CARD} target="_blank" rel="noreferrer">Prepaid Cards</a></li>
                  <li><a href={LINK_GIFTCARD_LANDING} target="_blank" rel="noreferrer">Gift Cards</a></li>
                  <li><a href={LINK_ZAGGLE_CREDIT_CARDS} target="_blank" rel="noreferrer">Credit Cards</a></li>
                  <li><a href={ZAGGLE_CLOSED_LOOP_CARDS} target="_blank" rel="noreferrer">Closed Loop Cards</a></li>
                  <li><a href={LINK_FOREX_SERVICES} target="_blank" rel="noreferrer">Forex Services</a></li>
                </div>
              </ul>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} className="flex-center">
              <ul>
                <h4 className="border-left-primary">COMPANY</h4>
                <div className="margin-l-1">
                  <li><a href={ABOUT_US}>About Zaggle</a></li>
                  <li><a href={CAREERS}>Careers</a></li>
                  <li><a href={PRESS}>Press</a></li>
                  <li><a href={CONTACT_US}>Contact Us</a></li>
                  <li><a href={TRUST_CENTER} target="_blank" rel="noreferrer">Trust Center</a></li>
                  <li><a href={FAQS}>FAQs</a></li>
                  <li><a href={INVESTOR_RELATIONS}>Investor Relations</a></li>
                </div>
              </ul>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} className="flex-center">
              <ul>
                <h4 className="border-left-primary">SOLUTIONS</h4>
                <div className="margin-l-1">
                  <li><a href={SOLUTIONS_MID_RANGE_COMPANIES}>Mid-Sized Companies</a></li>
                  <li><a href={SOLUTIONS_CORPORATE}>Enterprises</a></li>
                </div>
              </ul>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} xl={6} className="flex-center">
              <ul>
                <h4 className="border-left-primary">CONTACT US ON</h4>
                <li>
                  <div className="flex">
                    <div className="flex">
                      <img src="https://cdn.zaggle.in/images/web/zaggle/landing/svg/contact-call-icon.svg" alt="icon" width="0" height="0" sizes="100vw" className="contact-img" />
                    </div>
                    <div>
                      <p className="contact-p-margin font-12-p">Monday–Friday</p>
                      <p className="font-12-p">
                        Toll Free – <a href="tel:04023119049">040 2311 9049</a>
                      </p>
                    </div>

                  </div>
                </li>
                <li>
                  <div className="flex">
                    <div className="flex">
                      <img src="https://cdn.zaggle.in/images/web/zaggle/landing/svg/contact-email-icon.svg" alt="icon" width="0" height="0" sizes="100vw" className="contact-img" />
                    </div>
                    <div>
                      <p className="contact-p-margin font-12-p">Email Us</p>
                      <p className="font-12-p">
                        <a href="mailto:Support@Zaggle.in">Support@Zaggle.in</a>
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} className="web-d-none margin-auto">
              <ul>
                <li>
                  <a target="_blank" href={ANDROID_APP} rel="noreferrer">
                    <img src={endPoints.ZAGGLE_PLAY_STORE.URL} alt={endPoints.ZAGGLE_PLAY_STORE.ALT} />
                  </a>
                </li>
                <li>
                  <a target="_blank" href={IOS_APP} rel="noreferrer">
                    <img src={endPoints.ZAGGLE_APP_STORE.URL} alt={endPoints.ZAGGLE_APP_STORE.ALT} />
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
          <Row align="middle" className="footer-links">
            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="mbl-d-none">
              <ul className="download-app flex margin-l-1">
                <li>
                  <a target="_blank" href={ANDROID_APP} rel="noreferrer">
                    <img src={endPoints.ZAGGLE_PLAY_STORE.URL} alt={endPoints.ZAGGLE_PLAY_STORE.ALT} />
                  </a>
                </li>
                <li>
                  <a target="_blank" href={IOS_APP} rel="noreferrer">
                    <img src={endPoints.ZAGGLE_APP_STORE.URL} alt={endPoints.ZAGGLE_APP_STORE.ALT} />
                  </a>
                </li>
              </ul>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="margin-t-2">
              <ul className="social_media">
                {SOCIAL_DATA.map((item) => (
                  <li key={item.name}>
                    <a href={item.link} target="_blank" rel="noreferrer">
                      <div dangerouslySetInnerHTML={{ __html: item.name }} />
                    </a>
                  </li>
                ))}
              </ul>
            </Col>
          </Row>
        </CustomContainer>
        <div className="copyrights">
          <CustomContainer>
            <Row align="middle" gutter={0} className="padding-b-2">
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="web-d-none">
                <Row align="middle" gutter={0} className="padding-b-2 margin-t-2">
                  <Col xs={12} sm={12} md={12} lg={12} xl={12} className="padding-b-2">
                    <a className="text-black" href={GRIVANCE_POLICY}>Grievance Policy</a>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12} className="padding-b-2">
                    <a className="text-black" href={REFUND_POLICY}>Refund Policy</a>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <a className="text-black" href={PRIVACY_POLICY}>Privacy Policy</a>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <a className="text-black" href={TERMS_AND_CONDITIONS}>Terms and Conditions</a>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} sm={24} md={4} lg={4} xl={4} className="text-left mbl-text-center">
                <img src={endPoints.ZAGGLE_LOGO.URL} className="zaggle-logo" alt="" />
              </Col>
              <Col xs={24} sm={24} md={10} lg={10} xl={10} className="margin-t-3">
                <p className="margin-auto text-left mbl-text-center mbl-margin-b-2 font-14">&copy; Zaggle {currentYear} - All Rights Reserved</p>
              </Col>
              <Col xs={24} sm={24} md={10} lg={10} xl={10} className="mbl-d-none margin-t-3">
                <ul className="flex-end-right">
                  <li><a href={GRIVANCE_POLICY}>Grievance Policy</a></li>
                  <li><a href={REFUND_POLICY}>Refund Policy</a></li>
                  <li><a href={PRIVACY_POLICY}>Privacy Policy</a></li>
                  <li><a href={TERMS_AND_CONDITIONS}>Terms and Conditions</a></li>
                </ul>
              </Col>
            </Row>
          </CustomContainer>
        </div>
      </StyledFooter>
    </FooterSegment>
  );
}

export default FooterNew;



// WEBPACK FOOTER //
// client/components/FooterNew/index.js